import React from 'react';
import { Container, Grid, Card, CardMedia, CardContent, Typography, Box } from '@mui/material';
import hamRadioImage from '../images/ham_radio.jpg';
import fieldDayImage from '../images/field_day.jpg';
import radioSetupImage from '../images/radio_setup.jpg';

const cards = [
  {
    title: 'Introduction to Ham Radio',
    image: hamRadioImage,
    text: 'Amateur radio, also known as ham radio, allows licensed operators to communicate over various frequencies. It plays a crucial role in emergency communication and community events.',
  },
  {
    title: 'Field Day Events',
    image: fieldDayImage,
    text: 'Jordan regularly participates in Field Day events, where amateur radio operators set up temporary stations and practice emergency response communications.',
  },
  {
    title: 'Advanced Radio Setup',
    image: radioSetupImage,
    text: "Jordan's advanced radio setup includes high-frequency transceivers, antennas, and digital modes, enabling him to communicate with operators worldwide.",
  },
];

const HamRadio = () => {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom>
        Amateur Radio (Ham Radio)
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 5, maxWidth: 800 }}>
        Jordan Webb, known by his callsign NA4WX, is a dedicated amateur radio operator. His journey in ham radio
        began at the age of 12, and he has since become an integral part of the community, providing vital
        communication services and participating in numerous radio events.
      </Typography>
      <Grid container spacing={3} sx={{ mb: 5 }}>
        {cards.map((card) => (
          <Grid size={{ xs: 12, md: 4 }} key={card.title}>
            <Card sx={{ height: '100%' }}>
              <CardMedia component="img" height="200" image={card.image} alt={card.title} />
              <CardContent>
                <Typography variant="h6" component="h2" gutterBottom>
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" component="h3" gutterBottom>
          Roles and Contributions
        </Typography>
        <Typography variant="body1" color="text.secondary">
          As the District 5 Assistant Skywarn Coordinator, Jordan plays a pivotal role in monitoring severe weather
          conditions and providing real-time reports to the National Weather Service. His commitment to public
          safety and communication excellence is evident in his proactive approach to emergency preparedness.
        </Typography>
      </Box>
      <Box>
        <Typography variant="h5" component="h3" gutterBottom>
          Community Involvement
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Beyond operating on the air, Jordan builds and maintains open source software and web infrastructure for
          the amateur radio community. This includes hosting and websites for repeater owners, clubs, and
          public-safety programs like SKYWARN, giving fellow hams the tools and online presence they need to keep
          their organizations connected.
        </Typography>
      </Box>
    </Container>
  );
};

export default HamRadio;
